import { Stack, alpha } from '@mui/material';
import React from 'react';
import { useBlendColors } from 'hooks/useDesign';

export default function PanelWrapper({ children }: { children: React.ReactNode }) {
    return (
        <Stack
            justifyContent={'space-between'}
            direction={'row'}
            sx={{
                backgroundColor: (theme) => useBlendColors(alpha(theme.palette.text.primary, 0.04)),
                border: '1px solid',
                borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                borderRadius: 1,
                p: 0.75,
            }}
        >
            {children}
        </Stack>
    );
}
